module.exports = window.runtimeConfig;